import { render, staticRenderFns } from "./VeJwBjggManageList.vue?vue&type=template&id=751dfcb0&scoped=true"
import script from "./VeJwBjggManageList.vue?vue&type=script&lang=js"
export * from "./VeJwBjggManageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751dfcb0",
  null
  
)

export default component.exports